module.exports = __webpack_public_path__ + "img/1594740377.49fc2b9f.jpg";